module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURTRJXj9TZ11uf/n6+pSfqkhbbvT29////+bp7HKAj1FjdYGOm6ixure+xtvf42Z2htHW21lqe52nsYyYpLzDyrC4wMLJz0ZMmxoAAADZSURBVBjTVVFZFoQgDAv7Ighuc/+jTlt0RvohJq80SUGQMmdSgGrVDAz5FgA5pY2O8qN9g/6Mrp7g4qCNwxV+VZe7W6OHd5XEdEGd2BOKaWwT2wHfI+o8IoKEYKHxZr2DDkFlzDPIOfk7yD8ZSm0dbAJ2Oi6ijxAsYDn1QlnFO9FtYHf6nZBco5+M+zZoV7AySysU1uCoXPnen4VBks06PCMotwfpCYhK1KV54VU5eAZrboNlNUje9ZVzYzH2ER2sf7YqMe9HI9/a1ro3Cm3+bxmiFSfuiAN/AZlXDGQT92d1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/loan_state.png
// module id = 1821
// module chunks = 5